import { MutationOptions, useMutation } from '@tanstack/react-query';
import { acceptPSATermsService } from '../acceptPSATermsService';
import {
  IAcceptPSATermsPayload,
  IAcceptPSATermsResponse,
} from '../acceptPSATermsTypes';

export const useAcceptPSATerms = (
  options?: MutationOptions<
    IAcceptPSATermsResponse,
    Error,
    IAcceptPSATermsPayload,
    unknown
  >
) => {
  return useMutation<IAcceptPSATermsResponse, Error, IAcceptPSATermsPayload>({
    mutationFn: async (payload: IAcceptPSATermsPayload) => {
      return acceptPSATermsService.acceptPSATerms(payload);
    },
    ...options,
  });
};
